import React from 'react';
import { BillHeader } from './BillHeader';
import { BillSupplierInfo } from './BillSupplierInfo';
import { BillExchangeOrders } from './BillExchangeOrders';
import { BillTotals } from './BillTotals';
import { BillRemarks } from './BillRemarks';
import { BillApproval } from './BillApproval';
export function Bill() {
  const companyInfo = {
    name: 'MyTourix Travel Management',
    address: ['123 Orchard Road, #12-34', 'Singapore 238858'],
    phone: '+65 6789 1234',
    email: 'accounts@mytourix.com'
  };
  const billInfo = {
    number: 'BILL-2025-00123',
    status: 'Approved' as const,
    billDate: '20 January 2025',
    dueDate: '05 February 2025',
    totalDueAmount: 8450.75,
    matchedAmount: 5000.0,
    outstandingAmount: 3450.75,
    createdBy: 'Sarah Chen',
    lastUpdated: '22 Jan 2025, 10:30 AM',
    printedBy: 'System Admin',
    printingDate: '23 Jan 2025, 2:15 PM'
  };
  const supplierInfo = {
    name: 'Grand Hyatt Singapore',
    reference: 'SUP-INV-2025-456',
    invoiceDate: '18 January 2025',
    dueDate: '05 February 2025',
    contact: 'Reservations Department',
    email: 'reservations@hyatt.com',
    phone: '+65 6738 1234'
  };
  const exchangeOrders = [{
    serialNo: 1,
    eoRef: 'EO-2025-00156',
    tourCode: 'TOUR-JP-001',
    issueDate: '15 Jan 2025',
    dueDate: '05 Feb 2025',
    currency: 'SGD',
    amount: 3450.5
  }, {
    serialNo: 2,
    eoRef: 'EO-2025-00178',
    tourCode: 'TOUR-JP-002',
    issueDate: '18 Jan 2025',
    dueDate: '05 Feb 2025',
    currency: 'SGD',
    amount: 2800.0
  }, {
    serialNo: 3,
    eoRef: 'EO-2025-00192',
    tourCode: 'TOUR-SG-045',
    issueDate: '20 Jan 2025',
    dueDate: '05 Feb 2025',
    currency: 'SGD',
    amount: 2200.25
  }];
  const totals = {
    subtotalEOAmount: 8450.75,
    matchedAmount: 5000.0,
    totalDueAmount: 8450.75,
    outstandingAmount: 3450.75
  };
  const remarks = `This bill consolidates three exchange orders for hotel bookings with Grand Hyatt Singapore for the month of January 2025.

Payment terms: Net 15 days from invoice date.
Payment method: Telegraphic Transfer (TT) to supplier's DBS account.

Partial payment of SGD 5,000.00 has been matched against this bill on 22 Jan 2025 (Payment Ref: PAY-2025-089).

Outstanding balance of SGD 3,450.75 is due by 05 Feb 2025.

Please ensure all payments reference the Bill No. and Supplier Invoice No. for proper reconciliation.`;
  return <div className="h-full overflow-auto bg-gradient-to-br from-neutral-50 to-neutral-100 p-6" data-id="element-1">
      <div className="w-[210mm] min-h-[297mm] max-h-[297mm] mx-auto bg-white shadow-lg rounded-xl p-8 flex flex-col" data-id="element-2">
        <BillHeader company={companyInfo} bill={billInfo} data-id="element-3" />
        <BillSupplierInfo supplier={supplierInfo} data-id="element-4" />
        <div className="flex-1 overflow-hidden" data-id="element-5">
          <BillExchangeOrders orders={exchangeOrders} data-id="element-6" />
          <BillTotals {...totals} data-id="element-7" />
          <BillRemarks remarks={remarks} data-id="element-8" />
          <BillApproval preparedBy="Sarah Chen" checkedBy="Finance Team" approvedBy="John Tan" data-id="element-9" />
        </div>

        {/* Footer */}
        <p className="text-xs text-neutral-500 italic text-center pt-4 border-t border-neutral-200" data-id="element-10">
          Generated by system. No signature required.
        </p>
      </div>
    </div>;
}